var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPhotocopiesOutlined = function SvgHtlPhotocopiesOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.413 13.559a1.627 1.627 0 0 1-.411-1.15c0-.305.014-5.986 0-6.963a1.4 1.4 0 0 1 .412-1.093 1.43 1.43 0 0 1 1.008-.352H4.47a.5.5 0 0 1 0 1H3.368a.435.435 0 0 0-.275.086.5.5 0 0 0-.093.345c.016 1.008 0 6.749 0 6.993v.032a.632.632 0 0 0 .138.416.608.608 0 0 0 .46.13c1.182-.031 4.799 0 4.955 0a.5.5 0 0 1 0 1c-.037 0-3.754-.031-4.92 0h-.06a1.525 1.525 0 0 1-1.16-.444ZM7 12a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7Zm0-1h6V3H7v8Zm1.5-4a.5.5 0 0 1 0-1h2a.5.5 0 1 1 0 1h-2Zm0-2a.5.5 0 0 1 0-1h3a.5.5 0 1 1 0 1h-3Z"
  })));
};
export default SvgHtlPhotocopiesOutlined;